<template>
  <div>
    <v-overlay :value="loading" class="align-center justify-center">
      <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-snackbar v-model="error.show">
      <p class="py-0 my-0 font-weight-black">{{ error.title }}</p>
      {{ error.message }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="error.show = false">
          Fechar
        </v-btn>
      </template>
    </v-snackbar>

    <v-alert type="info" border="left" colored-border elevation="2" class="ma-3">
      <div class="text-h6 mb-2">
        Informações sobre o faturamento
      </div>
      <ul class="ml-4">
        <li>As faturas são geradas automaticamente todo <strong>dia 01</strong> de cada mês</li>
        <li>Data de vencimento: <strong>dia 10</strong> de cada mês</li>
        <li>As faturas são enviadas para os contatos informados no credenciamento</li>
        <li class="error--text">Pagamento em atraso pode acarretar juros e bloqueio das lojas dos seus clientes</li>
      </ul>
    </v-alert>

    <v-container class="ma-0" fluid>
      <v-data-table :headers="headers" :items="faturasFiltradas" sort-by="nome" class="elevation-1"
        :loading="loadingLista" loading-text="Carregando..." :search="pesquisar"
        @dblclick:row="($event, { item }) => pagar(item.invoiceUrl)" :footer-props="{
          'items-per-page-options': [10, 25, 50, 100, 250, 500, 1000, -1],
        }" :items-per-page="12" locale="pt" item-key="data">

        <template v-slot:top>
          <v-toolbar flat v-if="!loadingLista">
            <v-text-field v-model="pesquisar" append-icon="mdi-magnify" label="Pesquisar" single-line
              hide-details></v-text-field>

            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn :color="mostrarHistorico ? 'primary' : 'grey'" dark class="mb-2 ml-2" v-bind="attrs" v-on="on"
                  @click="mostrarHistorico = !mostrarHistorico">
                  <v-icon small> mdi-history </v-icon>
                </v-btn>
              </template>
              <span>{{ mostrarHistorico ? 'Ocultar histórico' : 'Visualizar histórico' }}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="grey" dark class="mb-2 ml-2" v-bind="attrs" v-on="on" @click="atualizar()">
                  <v-icon small> mdi-refresh </v-icon>
                </v-btn>
              </template>
              <span>Atualizar lista</span>
            </v-tooltip>
          </v-toolbar>
        </template>

        <template v-slot:item.dateCreated="{ item }">
          <span>{{
            new Date(`${item.dueDate}T00:00:00`).toLocaleDateString('pt-BR', {
              timeZone: 'UTC', month:
                'long'
            }).replace(/^./, str => str.toUpperCase())
          }}</span>
        </template>

        <template v-slot:item.value="{ item }">
          <span>{{
            item.value.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            })
          }}</span>
        </template>

        <template v-slot:item.status="{ item }">
          <span>{{ status[item.status] }}
            {{
              item.paymentDate
              ? "em " +
              new Date(`${item.paymentDate}T00:00:00`).toLocaleString(
                "default",
                { day: "2-digit", month: "2-digit" }
              )
              : ""
            }}</span>
        </template>

        <template v-slot:item.opcoes="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" :color="cor[status[item.status]]" v-bind="attrs" v-on="on"
                @click="pagar(item.invoiceUrl)">
                mdi-credit-card
              </v-icon>
            </template>
            <span>Fatura</span>
          </v-tooltip>
        </template>

        <template v-slot:item.dueDate="{ item }">
          <span>{{
            new Date(`${item.dueDate}T00:00:00`).toLocaleDateString('pt-BR', { timeZone: 'UTC' })
          }}</span>
        </template>
      </v-data-table>
    </v-container>

  </div>
</template>

<script>
import {
  fetchApiClientes,
  asaasListarFaturas,
  responsavelGeralDados,
  validarRevenda,
  usarCreditos,
  asaasCriarFatura,
} from "../../services/api";
import { verificarSessao, getMes } from "../../utils/utils";

export default {
  name: "Faturas",
  data() {
    return {
      loading: false,
      loadingLista: true,
      error: {
        show: false,
        message: "",
        title: "",
      },
      headers: [
        { text: "Mês", value: "dateCreated" },
        { text: "Vencimento", value: "dueDate" },
        { text: "Descrição", value: "description" },
        { text: "Valor", value: "value" },
        { text: "Status", value: "status" },
        { text: "Opções", value: "opcoes", sortable: false },
      ],
      faturas: [],
      mostrarHistorico: false,
      pesquisar: "",
      status: {
        RECEIVED: "Pago",
        CONFIRMED: "Pago",
        RECEIVED_IN_CASH: "Pago",
        AWAITING_RISK_ANALYSIS: "Pendente",
        PENDING: "Pendente",
        OVERDUE: "Atrasado",
        REFUND_REQUESTED: "Estornado",
        REFUND: "Estornado",
        REFUNDED: "Estornado",
      },
      cor: {
        Pago: "green",
        Pendente: "orange",
        Atrasado: "red",
        Estornado: "red",
      },
      token: localStorage.getItem("token"),
      asaas_id_revenda: this.$route.params.asaas_id_revenda,
      inputs: {},
    };
  },
  computed: {
    faturasFiltradas() {
      if (this.mostrarHistorico) {
        return this.faturas;
      }
      const pendentes = ["AWAITING_RISK_ANALYSIS", "PENDING", "OVERDUE"];
      return this.faturas.filter((fatura) => pendentes.includes(fatura.status));
    },
  },
  async created() {
    window.addEventListener("offline", () => (this.loading = true));
    window.addEventListener("online", () => (this.loading = false));
    /**
     *
     */
    if (!this.asaas_id_revenda) {
      this.$router.push({ path: "/inicio" });
    }
    /**
     *
     */
    verificarSessao(this.gerarCobranca);
    setTimeout(verificarSessao, 1 * 60000);
  },
  methods: {
    setLoading(loading) {
      this.loading = loading;
      this.$root.$emit('global-loading', loading);
    },
    setError(error) {
      this.error = {
        show: true,
        title: "Ops, falhou!",
        message: error ? error : "Falha não identificada, tente novamente.",
      };
    },
    async atualizar() {
      this.loadingLista = true;
      return asaasListarFaturas(this.token, this.asaas_id_revenda)
        .then((response) => {
          this.loadingLista = false;
          this.faturas = response?.data?.faturas?.data;
        })
        .catch((error) => {
          this.loadingLista = false;
          this.setError(error);
        });
    },
    /**
     *
     */
    async gerarCobranca() {
      try {
        const faturas = await asaasListarFaturas(this.token, this.asaas_id_revenda);
        const ultimaFatura = faturas?.data?.faturas?.data?.filter(m => !m.externalReference || m.externalReference === "fatura_mensal_revenda").shift();
        if (ultimaFatura) {
          const mesAtual = new Date().toLocaleString("default", {
            month: "2-digit",
            year: "2-digit",
          });
          const mesUltimaFatura = new Date(
            `${ultimaFatura.dueDate}T00:00:00`
          ).toLocaleString("default", { month: "2-digit", year: "2-digit" });
          if (mesUltimaFatura === mesAtual) {
            throw new Error("A última fatura já foi gerada pra revenda.");
          }
        }

        let cobranca = 0;
        let total = {
          lojas: {
            qtd: 0,
            valor: 0,
          },
          lojas_demos: {
            qtd: 0,
            valor: 0,
          },
          lojas_bloqueadas: {
            qtd: 0,
            valor: 0,
          },
          fiscal: {
            valor: 0,
            qtd: 0,
            nfces: {
              qtd: 0,
            },
            nfes: {
              qtd: 0,
            },
            dfes: {
              qtd: 0,
            },
          },
          gamazaps: {
            qtd: 0,
            valor: 0,
          },
          gamazaps_campanhas: {
            qtd: 0,
            valor: 0,
          },
          robos: {
            qtd: 0,
            valor: 0,
          },
          gtefs: {
            qtd: 0,
            valor: 0,
          },
          gposs: {
            qtd: 0,
            valor: 0,
          },
          gmesass: {
            qtd: 0,
            valor: 0,
          },
          suporte: {
            qtd: 0,
            valor: 0,
          },
        };

        const clientes = await fetchApiClientes(this.token);

        clientes?.data?.clientes?.map((cliente) => {
          // Não cobrar
          if (cliente.nome === "demonstracao") {
            total.lojas_demos.qtd++;
            return;
          }

          // Não cobrar
          if (cliente.block === "🔴") {
            total.lojas_bloqueadas.qtd++;
            return;
          }

          // Cobrar
          if (cliente.ativo) {
            total.lojas.qtd++;
            total.lojas.valor += this.valorRevenda;
            cobranca += this.valorRevenda;
          }

          if (!cliente.analytics) {
            return;
          }

          const nfces = parseInt(cliente?.analytics?.fiscal60dias ?? 0);
          const nfes = parseInt(cliente?.analytics?.nfes60dias ?? 0);
          const dfes = parseInt(cliente?.analytics?.dfes60dias ?? 0);
          if (nfces > 0 || nfes > 0 || dfes > 0) {
            total.fiscal.nfces.qtd += nfces;
            total.fiscal.nfes.qtd += nfes;
            total.fiscal.dfes.qtd += dfes;
            total.fiscal.qtd += 1;
            total.fiscal.valor += this.valorFiscal;
            cobranca += this.valorFiscal;
          }

          const mesRef = cliente.analytics[`modulos_mes${getMes(-1)}`];
          const mesAnt = cliente.analytics[`modulos_mes${getMes(-2)}`];
          const mesAnt2 = cliente.analytics[`modulos_mes${getMes(-3)}`];
          if (mesRef || mesAnt || mesAnt2) {
            const getModulo = (modulo) =>
              parseInt(mesRef?.[modulo] ?? mesAnt?.[modulo] ?? mesAnt2?.[modulo] ?? 0);

            const gamazaps = getModulo("gamazap");
            if (gamazaps > 0) {
              total.gamazaps.qtd += gamazaps;
              total.gamazaps.valor += gamazaps * this.valorGamaZap;
              cobranca += gamazaps * this.valorGamaZap;
            }

            const gamazaps_campanhas = getModulo("gamazap_campanhas");
            if (gamazaps_campanhas > 0) {
              total.gamazaps_campanhas.qtd += gamazaps_campanhas;
              total.gamazaps_campanhas.valor += gamazaps_campanhas * this.valorGamaZapCampanhas;
              cobranca += gamazaps_campanhas * this.valorGamaZapCampanhas;
            }

            const robos = getModulo("robo");
            if (robos > 0) {
              total.robos.qtd += robos;
              total.robos.valor += robos * this.valorRobo;
              cobranca += robos * this.valorRobo;
            }

            const gtefs = getModulo("gtef");
            if (gtefs > 0) {
              total.gtefs.qtd += gtefs;
              total.gtefs.valor += gtefs * this.valorGtef;
              cobranca += gtefs * this.valorGtef;
            }

            const gposs = getModulo("gpos");
            if (gposs > 0) {
              total.gposs.qtd += gposs;
              total.gposs.valor += gposs * this.valorGpos;
              cobranca += gposs * this.valorGpos;
            }

            const gmesass = getModulo("gmesa");
            if (gmesass > 0) {
              total.gmesass.qtd += gmesass;
              total.gmesass.valor += gmesass * this.valorGmesas;
              cobranca += gmesass * this.valorGmesas;
            }

            const suporte = getModulo("suporte_dedicado");
            if (suporte > 0) {
              total.suporte.qtd += suporte;
              total.suporte.valor += suporte * this.valorSuporte;
              cobranca += suporte * this.valorSuporte;
            }
          }
        });

        if (total.lojas.qtd < this.qtdMinimoLojasRevenda) {
          cobranca -= total.lojas.valor;
          cobranca += this.valorMinimoRevenda;
          total.lojas.valor = this.valorMinimoRevenda;
        }

        let descricao = "";
        if (this.isDesenvolvimento) {
          descricao += `(DEV) `;
          cobranca = 100;
        }

        descricao += `${total.lojas.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} - ` + (total.lojas.qtd < this.qtdMinimoLojasRevenda ? `${total.lojas.qtd}/${this.qtdMinimoLojasRevenda} lojas mínimas \n ` : `${total.lojas.qtd} lojas \n `);

        descricao += `${total.lojas_demos.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} - ${total.lojas_demos.qtd} lojas de demonstração (não cobrado) \n `;

        descricao += `${total.lojas_bloqueadas.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} - ${total.lojas_bloqueadas.qtd} lojas bloqueadas (não cobrado) \n `;

        descricao += `${total.fiscal.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} - ${total.fiscal.nfces.qtd} NFC-e / ${total.fiscal.nfes.qtd} NF-e / ${total.fiscal.dfes.qtd} DF-e (${total.fiscal.qtd} lojas) \n `;

        descricao += `${total.gamazaps.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} - ${total.gamazaps.qtd} WhatsApp Conectados \n `;

        descricao += `${total.gamazaps_campanhas.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} - ${total.gamazaps_campanhas.qtd} WhatsApp Marketing \n `;

        descricao += `${total.robos.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} - ${total.robos.qtd} Robôs de atendimento \n `;

        descricao += `${total.gtefs.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} - ${total.gtefs.qtd} [G-TEF] POS ativos \n `;

        descricao += `${total.gposs.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} - ${total.gposs.qtd} G-POS \n `;

        descricao += `${total.gmesass.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} - ${total.gmesass.qtd} G-MESAS \n `;

        descricao += `${total.suporte.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} - ${total.suporte.qtd} Suporte ao cliente \n `;

        const { creditos } = await this.buscarRevenda();
        if (creditos > 0) {
          let creditosUtilizados = 0;

          if (creditos >= cobranca) {
            creditosUtilizados = cobranca;
            descricao += `\n -${creditosUtilizados.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} - crédito utilizado\n `;
          } else {
            creditosUtilizados = creditos;
            descricao += `\n -${creditos.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} - crédito utilizado\n `;
          }

          const usar = await usarCreditos(this.dominio, creditosUtilizados);
          if (!usar) {
            throw new Error("Não foi possível utilizar os créditos da revenda.");
          }

          cobranca -= creditosUtilizados;
        }

        const criarFatura = await asaasCriarFatura(this.token, {
          billingType: "PIX",
          interest: { value: 2 },
          fine: { value: 3, type: "PERCENTAGE" },
          customer: this.asaas_id_revenda,
          dueDate: `${new Date().getFullYear()}-${getMes()}-10`,
          value: cobranca,
          description: descricao,
          externalReference: "fatura_mensal_revenda",
          split: [
            {
              walletId: (this.isDesenvolvimento ? "7171bb1c-f2d2-4729-bf08-ec90431ccaf5" : "ec7ac8c2-9e1f-44c9-9d6e-bae9088523ea"),
              percentualValue: 20,
              externalReference: 'Investimentos',
            },
          ],
          callback: {
            successUrl: `https://painel.gamadelivery.app/redirecionar.php?url=${window.location.href}`,
            autoRedirect: true,
          },
        });
        if (!criarFatura) {
          throw new Error(
            "Não foi possível gerar a fatura do mês pra revenda."
          );
        }
      } catch (err) {
        console.error(err.message);
      } finally {
        await this.atualizar();
      }
    },
    /**
     *
     */
    async buscarRevenda() {
      const { data: revenda } = await responsavelGeralDados(this.token);
      const { data: dados } = await validarRevenda(this.dominio, revenda.responsavel?.nome_empresa);
      return { ...dados.data, api_key: revenda.responsavel?.api_key };
    },
    /**
     *
     */
    pagar(url) {
      window.location.href = url;
    },
  },
};
</script>

<style>
body {
  margin: 15px !important;
}
</style>
